import { EtabState, ETAB_STORE as s } from './types';
import { MutationTree } from 'vuex';
import { Etablissement } from '@/models/Etablissement';


export const mutations : MutationTree<EtabState> = {
  [s.SET_LIST_ETAB](state, etablissements : Array<Etablissement>) {
      state.listEtablissements = etablissements;
  },

  [s.SET_CURRENT_ETAB](state, etablissement : Etablissement) {
      state.currentEtab = etablissement;
    },
};